import Model from "@/models/Model";

export default class Rightsholder extends Model {

  get id() {
    return this.bol;
  }

  get address1() {
    return this.adr1;
  }

  get address2(){
    return this.adr2;
  }

  get address3() {
    return this.adr3;
  }

  get docUri() {
    return this.docuri;
  }

  // get padr() {
  //   return this.padr;
  // }

  get country() {
    return this.land;
  }

  get blCode1() {
    return this.blkod1;
  }

  get stappad() {
    return this.blkod2;
  }

  get blCode4() {
    return this.blkod4;
  }

  get jurfys() {
    return this.blkod3;
  }

  get name() {
    return this.cnamn;
  }

  get rowNumber() {
    return this.rownumber;
  }

  // get tel() {
  //   return this.tel;
  // }

  get orgNumber() {
    return this.orgnr;
  }

  get VATNumber() {
    return this.vatn;
  }

  get internationalCollectionAllowed() {
    return String(this.intc) === '1';
  }
}